import { useWorkOrderSystemOriginList } from '@/core/domain/workorder/WorkOrders/WorkOrders.hooks';
import { Select, SelectProps } from 'antd';

export default function WorkOrderSystemOriginSelect(
  props: Omit<SelectProps, 'options'>,
) {
  const systemOriginList = useWorkOrderSystemOriginList();

  return (
    <Select
      mode="multiple"
      options={systemOriginList.data?.systems.map((system) => ({
        value: system.id,
        label: system.name,
      }))}
      style={{ ...props.style, width: '100%' }}
      {...props}
    />
  );
}
